
import { useIsMobile } from "@/hooks/use-mobile";

interface BagDescriptionProps {
  description: string;
  bagId: string;
}

export const BagDescription = ({ description }: BagDescriptionProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={isMobile ? "" : "pr-44"}>
      {description ? (
        <div className="space-y-2">
          <p className="text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>
      ) : (
        <div className="space-y-2">
          <p className="text-muted-foreground leading-relaxed">
            No description available
          </p>
        </div>
      )}
    </div>
  );
};
